import React from 'react'
import { Box } from '@material-ui/core'
import { Info, LoanValueContainer, LoanValueContainerProps } from './components'
import { formatToRealStr } from '~/utils/format'

export type InfoContainerProps = LoanValueContainerProps & {
  loanCreatedAt: string,
  numberOfInstallments?: number,
  installmentValue: number
}

export const InfoContainer: React.FC<InfoContainerProps> = (props) => {
  const { numberOfInstallments, requestedAmountCents, installmentValue, loanCreatedAt } = props

  return (
    <Box sx={{
      display: 'flex',
      backgroundColor: 'badgeBackgroundColor.info.light',
      width: '100%',
      flexDirection: { xs: 'column', md: 'row' },
      borderRadius: 1,
      height: 'fit-content',
      paddingY: 3,
      paddingX: 4,
      gap: { md: 7, xs: 2 }
    }}>
      <LoanValueContainer requestedAmountCents={requestedAmountCents} />

      <Info
        title='Parcelamento'
        value={ `${numberOfInstallments || 0}x de R$ ${formatToRealStr(`${installmentValue}`)}`}
      />

      <Info
        title='Solicitação Iniciada em'
        value={loanCreatedAt}
      />

      <Info
        title='Status'
        value='Pré-aprovado'
      />
    </Box>
  )
}
